module.exports = __webpack_public_path__ + "static/media/purchase-head.abc256ab.svg";